import React from 'react';
import PropTypes from 'prop-types';
import noop from 'lodash/noop';
import find from 'lodash/find';
import SimpleModal from './SimpleModal';

const TITLE = 'Reading Lists';
const MODEL_TYPE = 'reading list';
const DEFAULT_URL = '/reading-lists/';

const ReadingListModal = ({
  params = [],
  campaignId = '',
  newReadingList = noop,
  ...props
}) => {
  const modelId = params[0] === 'reading-lists' && params[4];
  const getCollection = () => find(Account.get('campaign_reading_lists') || [], ({campaign_id}) => campaign_id === campaignId);
  const baseUrl = `${DEFAULT_URL}campaign/${campaignId}/reading-list/`;
  return (<SimpleModal
    title={TITLE}
    modelType={MODEL_TYPE}
    baseUrl={baseUrl}
    defaultUrl={DEFAULT_URL}
    modelId={modelId}
    getCollection={getCollection}
    newItem={newReadingList}
    {...props}
  />);
};

ReadingListModal.propTypes = {
  params: PropTypes.array,
  campaignId: PropTypes.string,
  newReadingList: PropTypes.func,
};

export default ReadingListModal;
